(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-rotator"]) return;
  try {
    
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.messages = [...this.querySelectorAll('[data-rotator-message]')];
      this.index = 0;
      this.paused = false;

      this.querySelectorAll('[data-rotator-copy]').forEach((chip) =>
        chip.addEventListener('click', () => this.copy(chip))
      );

      if (this.messages.length < 2) return;
      // Pause while someone is reading or interacting with the bar
      ['mouseenter', 'focusin'].forEach((type) => this.addEventListener(type, () => (this.paused = true)));
      ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => (this.paused = false)));
      this.timer = setInterval(() => this.next(), Number(this.dataset.interval) || 5000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    next() {
      if (this.paused || document.hidden) return;
      this.messages[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.messages.length;
      this.messages[this.index].classList.add('is-active');
    }

    copy(chip) {
      const label = chip.querySelector('[data-rotator-copy-label]');
      const code = chip.dataset.rotatorCopy;
      const done = () => {
        label.textContent = 'Copied';
        setTimeout(() => (label.textContent = code), 1600);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, () => {});
    }
  }

  if (!customElements.get('announcement-rotator')) customElements.define('announcement-rotator', AnnouncementRotator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-finder"] && !Shopify.designMode) return;
  try {
    
  class CartFinder extends HTMLElement {
    connectedCallback() {
      try {
        this.carts = JSON.parse(document.querySelector('[data-finder-carts]').textContent);
      } catch (error) {
        return;
      }

      this.steps = this.querySelector('[data-finder-steps]');
      this.question = this.querySelector('[data-finder-question]');
      this.options = this.querySelector('[data-finder-options]');
      this.result = this.querySelector('[data-finder-result]');
      this.request = this.querySelector('[data-finder-request]');
      this.backButton = this.querySelector('[data-finder-back]');
      this.resetButtons = this.querySelectorAll('[data-finder-reset]');
      this.path = [];

      this.backButton.addEventListener('click', () => {
        this.path.pop();
        this.render(true, -1);
      });
      this.resetButtons.forEach((button) =>
        button.addEventListener('click', () => {
          this.path = [];
          this.render(true, -1);
        })
      );

      document.querySelectorAll('[data-finder-open-request]').forEach((link) =>
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.openRequest(link.dataset.brand || '');
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
      );

      // Chips elsewhere on the page (e.g. "Works with") can open the finder at a brand and model
      document.querySelectorAll('[data-finder-path]').forEach((link) =>
        link.addEventListener('click', (event) => {
          const [brand, model] = link.dataset.finderPath.split('|');
          const known = this.carts.filter((cart) => cart.brand === brand);
          if (!known.length) return;
          event.preventDefault();
          this.path = known.some((cart) => cart.model === model) ? [brand, model] : [brand];
          this.render(true, 1);
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
      );

      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', () => this.writeRequestTags());

      this.brandSelect = this.querySelector('[data-request-brand]');
      if (this.brandSelect) this.brandSelect.addEventListener('change', () => this.toggleOtherBrand(true));

      // After a successful signup the page reloads with the success message showing.
      const success = this.querySelector('[data-request-success]');
      if (success) {
        this.steps.hidden = true;
        this.request.hidden = false;
        this.revealSuccess(success);
        return;
      }

      this.steps.hidden = false;
      this.render(false);

      // A rejected email reloads the page with an error inside the request form.
      if (this.querySelector('.cart-finder__message--error')) this.openRequest('');
    }

    // The reload lands on the form's anchor, which parks the message under the sticky header.
    // Drop that anchor so the browser stops jumping to it, and put the card in the middle of the screen instead.
    revealSuccess(message) {
      this.classList.add('cart-finder__card--done');
      // also clears "customer_posted" so a refresh or a shared link shows the finder again, not this message
      history.replaceState(null, '', window.location.pathname);

      const reveal = () => {
        this.scrollIntoView({ block: 'center', behavior: 'instant' });
        message.focus({ preventScroll: true });
      };
      reveal();
      if (document.readyState === 'complete') return;
      // once more after everything has loaded: late images and fonts move the card
      window.addEventListener('load', () => setTimeout(reveal, 150), { once: true });
    }

    // Finished steps show the answer given ("E-Z-GO" instead of "Brand") and lead back to that step.
    setProgress(level) {
      this.querySelectorAll('[data-finder-step]').forEach((step, index) => {
        const done = index < level;
        const answer = done ? this.path[index] : '';
        step.classList.toggle('is-done', done);
        step.classList.toggle('is-active', index === level);
        if (index === level) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
        step.textContent = '';

        if (!answer) {
          step.textContent = step.dataset.label;
          return;
        }

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cart-finder__step-answer';
        button.textContent = this.shortName(answer);
        button.title = answer;
        button.setAttribute('aria-label', `${step.dataset.label}: ${answer}. Change`);
        button.addEventListener('click', () => {
          this.path = this.path.slice(0, index);
          this.render(true, -1);
        });
        step.appendChild(button);
      });
    }

    // "Precedent (2009-2018)" reads as "Precedent" where space is tight
    shortName(value) {
      return value.replace(/\s*\([^)]*\)\s*$/, '') || value;
    }

    // The years a model tile covers, read from its cart blocks: "2013+", "2021-2027", or the range in its own name
    yearsFor(model, carts) {
      const named = model.match(/\(([^)]*\d{4}[^)]*)\)\s*$/);
      if (named) return named[1];
      const text = carts.map((cart) => `${cart.qualifier} ${cart.detail}`).join(' ');
      const years = (text.match(/\b(?:19|20)\d{2}\b/g) || []).map(Number);
      if (!years.length) return '';
      const first = Math.min(...years);
      const last = Math.max(...years);
      const open = /\bnewer\b|\d{4}\+/i.test(text);
      return open || first === last ? `${first}+` : `${first}-${last}`;
    }

    // Writes the question with the answer so far picked out in green
    setQuestion(text, highlight) {
      this.question.textContent = '';
      const at = highlight ? text.indexOf(highlight) : -1;
      if (at < 0) {
        this.question.textContent = text;
        return;
      }
      const mark = document.createElement('mark');
      mark.textContent = highlight;
      this.question.append(text.slice(0, at), mark, text.slice(at + highlight.length));
    }

    // Replays the entrance so a new question visibly arrives: from the right going forward, from the left going back
    playArrival(direction) {
      if (!direction) return;
      this.steps.style.setProperty('--finder-from', direction < 0 ? '-28px' : '28px');
      this.steps.classList.remove('is-moving');
      void this.steps.offsetWidth;
      this.steps.classList.add('is-moving');

      // the new tiles land where the last tap was; ignore a stray second tap while they arrive
      this.options.style.pointerEvents = 'none';
      clearTimeout(this.arrivalTimer);
      this.arrivalTimer = setTimeout(() => {
        this.options.style.pointerEvents = '';
      }, 320);
    }

    unique(values) {
      return values.filter((value, index) => value && values.indexOf(value) === index);
    }

    render(moveFocus, direction) {
      const [brand, model] = this.path;
      this.classList.remove('cart-finder__card--done');
      this.request.hidden = true;
      this.steps.hidden = false;
      this.result.hidden = true;
      this.result.innerHTML = '';
      this.options.innerHTML = '';
      this.options.hidden = false;
      this.backButton.hidden = this.path.length === 0;
      // finished steps in the progress strip lead back, so "Start over" only joins Back once there is a result
      this.resetButtons[0].hidden = true;
      this.setProgress(this.path.length);

      if (!brand) {
        this.setQuestion('What brand is your cart?');
        // brand tiles list their models, so they never pass for the model tiles that follow
        const brands = this.unique(this.carts.map((cart) => cart.brand));
        const subs = brands.map((name) =>
          this.unique(this.carts.filter((cart) => cart.brand === name).map((cart) => this.shortName(cart.model))).join(' · ')
        );
        this.addOptions(brands, 'Another brand', '', false, subs);
      } else if (!model) {
        this.setQuestion(`Which ${brand} model?`, brand);
        const ofBrand = this.carts.filter((cart) => cart.brand === brand);
        const models = this.unique(ofBrand.map((cart) => cart.model));
        const subs = models.map((name) => {
          const ofModel = ofBrand.filter((cart) => cart.model === name);
          const soon = ofModel.every((cart) => cart.status === 'coming_soon');
          return [this.yearsFor(name, ofModel), soon ? 'Coming soon' : ''].filter(Boolean).join(' · ');
        });
        this.addOptions(models, `Another ${brand} model`, brand, false, subs);
      } else {
        const matches = this.carts.filter((cart) => cart.brand === brand && cart.model === model);
        const chosen = this.path[2] ? matches.find((cart) => cart.qualifier === this.path[2]) : null;

        if (matches.length === 1 || chosen) {
          this.showResult(chosen || matches[0]);
        } else {
          this.setQuestion(matches.find((cart) => cart.question)?.question || `Which ${model}?`, this.shortName(model));
          this.addOptions(matches.map((cart) => cart.qualifier), '', brand, true);
        }
      }

      this.playArrival(direction);
      if (moveFocus) this.question.focus({ preventScroll: true });
    }

    addOptions(labels, otherLabel, requestBrand, wide, subs) {
      labels.forEach((label, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cart-finder__option' + (wide ? ' cart-finder__option--wide' : '');
        button.style.setProperty('--finder-order', index + 1);

        const name = document.createElement('span');
        name.className = 'cart-finder__option-label';
        name.textContent = subs ? this.shortName(label) : label;
        button.appendChild(name);
        if (subs && subs[index]) {
          const sub = document.createElement('span');
          sub.className = 'cart-finder__option-sub';
          sub.textContent = subs[index];
          button.appendChild(sub);
        }

        button.addEventListener('click', () => {
          this.path.push(label);
          this.render(true, 1);
        });
        this.options.appendChild(button);
      });

      if (!otherLabel) return;
      const other = document.createElement('button');
      other.type = 'button';
      other.className = 'cart-finder__option cart-finder__option--other';
      other.style.setProperty('--finder-order', labels.length + 1);
      other.textContent = otherLabel;
      other.addEventListener('click', () => this.openRequest(requestBrand));
      this.options.appendChild(other);
    }

    showResult(cart) {
      const comingSoon = cart.status === 'coming_soon';
      this.setQuestion(comingSoon ? 'Your programmer is on the way' : 'Your programmer');
      this.setProgress(3);
      this.options.hidden = true;
      this.resetButtons[0].hidden = false;

      const card = document.createElement('div');
      card.className = 'cart-finder__result-card';

      const info = document.createElement('div');
      const status = document.createElement('span');
      status.className = 'cart-finder__status' + (comingSoon ? ' cart-finder__status--soon' : '');
      status.textContent = comingSoon ? 'Coming soon' : 'Available now';
      const title = document.createElement('p');
      title.className = 'cart-finder__result-title';
      title.textContent = cart.title;
      const meta = document.createElement('p');
      meta.className = 'cart-finder__result-meta';
      const speed = document.createElement('strong');
      speed.textContent = cart.speed;
      meta.appendChild(speed);
      const rest = [cart.detail, cart.price ? `From ${cart.price}` : ''].filter(Boolean).join('  ·  ');
      if (rest) meta.appendChild(document.createTextNode(`  ·  ${rest}`));
      info.append(status, title, meta);

      const link = document.createElement('a');
      link.className = 'btn';
      link.href = cart.url || '#models';
      link.textContent = comingSoon ? 'Join the waitlist' : 'View programmer';

      card.append(info, link);
      this.result.appendChild(card);
      this.result.hidden = false;
    }

    openRequest(brand) {
      this.steps.hidden = true;
      this.request.hidden = false;
      const select = this.brandSelect;
      if (select) {
        const match = [...select.options].find((option) => brand && option.value.toLowerCase() === brand.toLowerCase());
        select.value = match ? match.value : '';
        this.toggleOtherBrand(false);
      }
      const focusTarget = select && !select.value ? select : this.querySelector('[data-request-model]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    isOtherBrand() {
      return this.brandSelect && this.brandSelect.value.trim().toLowerCase() === 'other';
    }

    // Choosing "Other" reveals a text field so visitors can name their brand.
    toggleOtherBrand(moveFocus) {
      const field = this.querySelector('[data-request-other-field]');
      const input = this.querySelector('[data-request-other]');
      if (!field || !input) return;
      const other = this.isOtherBrand();
      field.hidden = !other;
      input.required = other;
      if (!other) input.value = '';
      field.parentElement.classList.toggle('cart-finder__fields--other', other);
      if (other && moveFocus) input.focus({ preventScroll: true });
    }

    // Saves what the visitor asked for as customer tags, so the list can be segmented by brand later.
    writeRequestTags() {
      const field = this.querySelector('[data-request-tags]');
      if (!field) return;
      const baseTag = this.dataset.requestTag || 'cart-request';
      const clean = (text) => text.replace(/[,<>]/g, ' ').replace(/\s+/g, ' ').trim();
      const slug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const typedBrand = clean(this.querySelector('[data-request-other]')?.value || '');
      const brand = this.isOtherBrand() && typedBrand ? typedBrand : clean(this.brandSelect?.value || '');
      const model = clean(this.querySelector('[data-request-model]')?.value || '');
      const tags = ['newsletter', baseTag];
      if (brand) tags.push(`${baseTag}-${slug(brand)}`);
      if (brand || model) tags.push(`cart: ${`${brand} ${model}`.trim().slice(0, 120)}`);
      field.value = tags.join(', ');
    }
  }

  if (!customElements.get('cart-finder')) customElements.define('cart-finder', CartFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  class PdpStickyBar extends HTMLElement {
    connectedCallback() {
      this.trigger = document.getElementById('topAddToCart');
      this.button = this.querySelector('button');
      if (!this.trigger || !('IntersectionObserver' in window)) return;

      // Appears once the main Add to Cart button has scrolled out of view above the screen
      new IntersectionObserver(([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', scrolledPast);
        this.setAttribute('aria-hidden', String(!scrolledPast));
        this.button.tabIndex = scrolledPast ? 0 : -1;
      }).observe(this.trigger);

      // Uses the same fit-check popup as the main button
      this.button.addEventListener('click', () => {
        if (typeof window.showATCPopup === 'function') window.showATCPopup();
        else this.trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  if (!customElements.get('pdp-sticky-bar')) customElements.define('pdp-sticky-bar', PdpStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["programmer-list"] && !Shopify.designMode) return;
  try {
    
  class ProgrammerFilter extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-filter]')];
      this.groups = [...this.closest('section').querySelectorAll('[data-group]')];

      // Only offer chips for groups that are actually on the page
      this.buttons.forEach((button) => {
        const filter = button.dataset.filter;
        if (filter !== 'all' && !this.groups.some((group) => group.dataset.group === filter)) button.remove();
        button.addEventListener('click', () => this.show(filter));
      });
      this.hidden = false;
    }

    show(filter) {
      this.groups.forEach((group) => {
        group.hidden = filter !== 'all' && group.dataset.group !== filter;
      });
      this.buttons.forEach((button) => {
        const active = button.dataset.filter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active);
      });
    }
  }

  if (!customElements.get('programmer-filter')) customElements.define('programmer-filter', ProgrammerFilter);

  // Speedometers sweep up to their top speed the first time their card scrolls into view
  (() => {
    const gauges = document.querySelectorAll('.programmer-list [data-gauge]');
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!gauges.length || still || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('is-waiting');
          observer.unobserve(entry.target);
        }),
      { threshold: 0.6 }
    );
    gauges.forEach((gauge) => {
      gauge.classList.add('is-waiting');
      observer.observe(gauge);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
